/**
 * wl-product-card.js: add to cart from any Liquid-rendered product card
 * (snippets/wl-product-card.liquid) on any page.
 *
 * One document-level handler for [data-wl-cta="add-to-cart"]; cards a React component
 * manages carry data-wl-managed and are skipped (the component owns its click). The add
 * goes through CartBundleAdd.smartAdd (assets/cart-add-merge.js: bundles the cart-drawer
 * section into the response and opens the drawer, the same path the tier buttons use)
 * with a plain /cart/add.js fallback when that script is not on the page.
 *
 * Announces wl-pcard:add / wl-pcard:add-failed on the button (bubbling) with
 * { surface, product_handle, variant_id, price }; assets/analytics-posthog-funnel.js
 * turns those into PostHog events. Loaded by every section that renders the card;
 * the guard below makes a second load a no-op.
 */
(function () {
  'use strict';
  if (window.__wlProductCardBound) return;
  window.__wlProductCardBound = true;

  function emit(target, name, detail) {
    try {
      target.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail || {} }));
    } catch (e) { /* old browsers */ }
  }

  function addToCart(variantId) {
    var items = [{ id: variantId, quantity: 1 }];
    if (window.CartBundleAdd && typeof window.CartBundleAdd.smartAdd === 'function') {
      return window.CartBundleAdd.smartAdd(items);
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart_add ' + r.status);
      return r.json();
    }).then(function (parsed) {
      if (window.CartBundleAdd && typeof window.CartBundleAdd.notifyCartUI === 'function') return window.CartBundleAdd.notifyCartUI(parsed);
      return parsed;
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('[data-wl-cta="add-to-cart"]');
    if (!btn || btn.hasAttribute('data-wl-managed') || btn.classList.contains('is-busy')) return;
    e.preventDefault();
    var variantId = Number(btn.getAttribute('data-wl-variant'));
    if (!variantId) return;
    var card = btn.closest('[data-wl-pcard]');
    var detail = {
      surface: card ? card.getAttribute('data-wl-surface') : null,
      product_handle: btn.getAttribute('data-wl-product'),
      variant_id: variantId,
      price: Number(btn.getAttribute('data-wl-price')) || null
    };
    var label = btn.textContent;
    var status = card ? card.querySelector('[data-wl-status]') : null;
    var say = function (t) { if (status) status.textContent = t; };
    btn.classList.add('is-busy');
    btn.textContent = 'Adding…';
    say('Adding to cart');
    addToCart(variantId)
      .then(function () {
        btn.classList.remove('is-busy');
        btn.classList.add('is-added');
        btn.textContent = 'Added';
        say('Added to cart');
        emit(btn, 'wl-pcard:add', detail);
        setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = label; say(''); }, 1600);
      })
      .catch(function (err) {
        btn.classList.remove('is-busy');
        btn.textContent = 'Try again';
        // err.message already carries the real reason when there is one — a Shopify
        // cart-validation rejection (e.g. a purchase-limit message) or the theme's own
        // friendly text (assets/cart-add-merge.js's describeFailedResponse) — so show
        // that instead of a generic line that hides why the add actually failed.
        var reason = (err && err.message) || 'Could not add to cart, try again';
        say(reason);
        if (window.CartBundleAdd && typeof window.CartBundleAdd.showToast === 'function') {
          window.CartBundleAdd.showToast(reason);
        }
        detail.error = String(reason).slice(0, 120);
        emit(btn, 'wl-pcard:add-failed', detail);
        setTimeout(function () { btn.textContent = label; say(''); }, 2400);
      });
  });
})();
